import { LogTypeEnum } from '@/types/simulation'

export enum LogOperator {
  Equal = 0,
  NotEqual = 1,
  /** Not supported by every environment's BE yet. */
  In = 2,
}

export interface LogDataFilterRule {
  /** Position in the log's `data` array. */
  index: number
  operator: LogOperator
  /** Required by the API even for `In`; send '' then. */
  value: string
  values?: string[]
}

export interface CrysbergLogsRequest {
  interfaceId: number
  logTypes: LogTypeEnum[]
  dataFilterRules?: LogDataFilterRule[]
  /** ISO date-time */
  from?: string
  to?: string
}

export interface InterfaceLog {
  interfaceId: number
  idx: number
  timestamp: string
  type: LogTypeEnum
  ts: number
  data: string[]
}
